import PropTypes from 'prop-types';

function MMBakeryActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11315)">
                <path
                    d="M4.86003 15.8204C3.5617 12.5039 3.1931 11.8394 2.27125 9.61215C1.19049 7.00156 1.58135 2.62113 5.07302 1.49509C7.79596 0.620127 10.0793 1.81576 12.2238 5.65139C14.1288 9.04699 15.433 12.7728 16.1435 14.4432C16.854 16.1136 20.7515 22.5651 20.0015 26.1554C19.4718 28.7081 16.4273 30.9272 12.9386 29.1977C9.78494 27.6312 9.30354 25.7561 7.5685 22.0167C5.83346 18.2772 4.86003 15.8204 4.86003 15.8204Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.89411 14.1462C7.33328 13.1363 8.88467 9.43906 13.448 10.7892C11.9489 12.5944 6.89411 14.1462 6.89411 14.1462Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.89192 18.9577C9.32617 17.9469 10.8776 14.2496 15.4408 15.5997C13.9428 17.4001 8.89192 18.9577 8.89192 18.9577Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5538 25.8026C11.987 24.7967 13.5394 21.0945 18.1017 22.4496C16.6086 24.2509 11.5538 25.8026 11.5538 25.8026Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.1707 9.42125C4.60399 8.41537 6.15635 4.71318 10.7187 6.06821C9.22553 7.86951 4.1707 9.42125 4.1707 9.42125Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.9213 20.3961C14.7953 21.9402 17.143 23.5474 18.1554 23.6853C18.8093 23.7798 23.6347 24.0201 25.3365 24.2407C27.0382 24.4613 27.6291 24.2643 27.7197 23.122C27.8103 21.9796 28.2042 18.1665 28.1963 17.2684C28.1884 16.3702 28.669 16.319 29.1968 15.996C30.1462 15.417 29.9059 13.3095 29.3977 12.5335C28.8896 11.7575 28.3066 10.9106 25.4901 10.4221C24.3083 10.2133 23.1266 10.0873 22.5554 10.0282C20.7552 9.88638 16.6467 9.63428 16.6467 9.63428C16.4852 11.5487 14.9883 15.287 15.6225 15.8385C15.9101 16.0866 15.268 17.4456 15.2522 17.8553C15.2115 18.7098 15.1009 19.5596 14.9213 20.3961V20.3961Z"
                    fill="#F1C34B"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.3657 16.559C28.3657 16.559 25.3995 16.3502 21.1216 16.2557C19.1244 16.2163 19.7822 20.2972 19.9398 23.6416C20.2392 23.7716 24.4147 24.1655 25.9864 24.3073C27.5581 24.4491 27.6291 24.0709 27.7669 22.6095C27.9048 21.1481 27.9166 19.2927 28.3657 16.559Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.1357 19.3519C11.0136 20.9 10.3124 22.9917 11.3208 23.1335C11.9747 23.228 16.4418 23.4683 18.1553 23.685C19.8688 23.9016 20.4479 23.7086 20.5385 22.5702C20.6291 21.4318 21.023 17.6147 21.0112 16.7127C20.9994 15.8106 21.4839 15.7673 22.0157 15.4443C22.965 14.8652 22.7247 12.7578 22.2126 11.9778C21.7005 11.1978 21.1254 10.3588 18.2932 9.86641C16.6877 9.61044 15.0589 9.53118 13.4362 9.63006C11.636 9.79157 10.1982 10.8118 10.08 12.226C9.92244 14.1365 10.3754 14.3531 11.0097 14.9007C11.1449 15.0489 11.2469 15.2244 11.3087 15.4153C11.3706 15.6062 11.3908 15.8082 11.3681 16.0076C11.3169 17.2405 11.1357 19.3519 11.1357 19.3519Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11315">
                    <rect width="30" height="30" fill="white" transform="translate(0.780762 0.380859)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMBakeryActive;

MMBakeryActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMBakeryActive.defaultProps = {
    className: null,
};
